import React from 'react';
import Icon from '../Icon';

export default function StatusBadge({ status, size = 'default' }) {
  const configs = {
    not_invited: {
      icon: 'mail-outline',
      label: 'Not Invited',
      bg: 'rgb(241, 245, 249)',
      text: 'rgb(100, 116, 139)',
      border: 'rgb(226, 232, 240)'
    },
    invited: {
      icon: 'send-outline',
      label: 'Invited',
      bg: 'rgb(224, 242, 254)',
      text: 'rgb(2, 132, 199)',
      border: 'rgb(186, 230, 253)'
    },
    opened: {
      icon: 'eye-outline',
      label: 'Opened',
      bg: 'rgb(204, 251, 241)',
      text: 'rgb(14, 116, 144)',
      border: 'rgb(153, 246, 228)'
    },
    in_progress: {
      icon: 'time-outline',
      label: 'In Progress',
      bg: 'rgb(254, 243, 199)',
      text: 'rgb(217, 119, 6)',
      border: 'rgb(253, 230, 138)'
    },
    enrolled: {
      icon: 'checkmark-circle',
      label: 'Enrolled',
      bg: 'rgb(220, 252, 231)',
      text: 'rgb(22, 163, 74)',
      border: 'rgb(187, 247, 208)'
    },
    declined: {
      icon: 'close-circle-outline',
      label: 'Declined',
      bg: 'rgb(254, 226, 226)',
      text: 'rgb(220, 38, 38)',
      border: 'rgb(254, 202, 202)'
    }
  };

  const config = configs[status] || configs.not_invited;
  const isSmall = size === 'small';

  return (
    <div
      data-testid={`status-badge-${status}`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: isSmall ? 4 : 6,
        padding: isSmall ? '4px 8px' : '6px 12px',
        borderRadius: 6,
        background: config.bg,
        border: `1px solid ${config.border}`,
        fontSize: isSmall ? 11 : 12,
        fontWeight: 600,
        color: config.text
      }}
    >
      <Icon name={config.icon} style={{ fontSize: isSmall ? 12 : 14 }} />
      {config.label}
    </div>
  );
}
